export class AiModels {
  static readonly gpt4o = 'gpt-4o';
  static readonly gpt41Nano = 'gpt-4.1-nano';
}
